import G from './Getters';
import FigureImageExpansionTemplateLayoutContainer from './FigureImageExpansionTemplateLayoutContainer';




export default function MicroscopyTemplateThumbnail({template,templateId, onEvent, }){

  return (
    <div class="sg-col" style={{ 
      //pointerEvents:'none',
      minHeight:0,
      background:'#f0f0f0',
      position:'relative',
    }}>

      <FigureImageExpansionTemplateLayoutContainer {...{
        template,
        thumbnail:true,
        onEvent,
      }}/>

      
    </div>
  )

}
